module.exports = __webpack_public_path__ + "static/media/logo.78d62dad.svg";